export default __webpack_public_path__ + "static/media/meals_card_1@3x.b9471f74.png";